import mixin from 'scripts/lib/mixin';

import DocumentStoreSaveResultHandler from '../lib/document_store_save_result_handler';

export default class OutgoingCallGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  get store() {
    return this.context.stores.activeCall;
  }

  handleAddSuccess() {
    // this handles the committing and subscribing of the active call for both outgoing WebRTC and Direct Dial calls
    this.handleSetSuccess();
    let activeCall = this.context.stores.activeCall.get();
    if (!activeCall) {
      return;
    }

    this.context.gateways.activeCall.cancelFetches();
    this.context.gateways.customerHistoryMerge.subscribe(activeCall.customer.id);
    this.context.gateways.conversationItem.request(activeCall.customer.id, activeCall.conversationItem.id);

    if (!this.isCustomerLoaded(activeCall.customer.id)) {
      this.context.gateways.customerProfile.request({ customerId: activeCall.customer.id });
    }
  }

  handleAddErrors(errorDtos) {
    this.handleSetErrors(errorDtos);
  }

  isCustomerLoaded(customerId) {
    return this.context.stores.customers.has({ id: customerId });
  }
}

mixin(OutgoingCallGatewayObserver.prototype, DocumentStoreSaveResultHandler.prototype);



// WEBPACK FOOTER //
// ./src/scripts/application/actions/phone_call/outgoing_call_gateway_observer.js